var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('router-link',_vm._b({attrs:{"tag":"img","src":_vm.headerLogo,"alt":"Header Logo"}},'router-link',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }